/* eslint-disable react/no-unused-state */
import React from "react";
import TextField from "@material-ui/core/TextField";
import "../contractStyle.css";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import Typography from "@material-ui/core/Typography";
import { ExpansionPanelView } from "../../../../shared/widgets";

function TextFieldComponent(props) {
  return (
    <TextField
      {...props}
      inputProps={{
        readOnly: Boolean(true),
      }}
    />
  );
}

export class ContractDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
    };
  }

  componentDidMount() {
    const { values, setDefaultBorneBy } = this.props;
    let borneByDefaultValue = values.checkedVehicles[0].borneBy || "operator";
    values.checkedVehicles.forEach((item) => {
      if (typeof item.borneBy !== "undefined" && borneByDefaultValue !== item.borneBy) {
        borneByDefaultValue = "";
      }
    });
    setDefaultBorneBy(borneByDefaultValue);
  }

  render() {
    const { values, handleChange } = this.props;
    const errors = values.contractDetailError;

    return (
      <form className="form-horizontal">
        <div className="contractDetailsWrapper">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container spacing={2}>
              <Grid item xs={3} className="customDateWrapper">
                <KeyboardDatePicker
                  required
                  autoOk
                  animateYearScrolling
                  error={!!(errors && errors.from)}
                  helperText={errors && errors.from ? "Required" : ""}
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="from"
                  label="From"
                  minDate={(typeof (values.requestType) === "string" && values.requestType === "edit") ? (new Date()).setDate(new Date().getDate() + 1) : undefined}
                  value={values.from}
                  onChange={handleChange("from", "value")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  TextFieldComponent={TextFieldComponent}
                />
              </Grid>
              <Grid item xs={3} className="customDateWrapper">
                <KeyboardDatePicker
                  required
                  autoOk
                  disableToolbar
                  error={!!(errors && errors.to)}
                  helperText={errors && errors.to ? errors.to : ""}
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="to"
                  label="To"
                  minDate={values.from ? values.from : null}
                  value={values.to}
                  onChange={handleChange("to", "value")}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  TextFieldComponent={TextFieldComponent}
                />
              </Grid>
            </Grid>

          </MuiPickersUtilsProvider>
          <Grid container spacing={2} className="expansionPanelWrapper">
            {errors && errors.checkedVehicles ? (
              <Typography className="errorStyle">Atleast 1 vehicle required</Typography>
            ) : null}
            <ExpansionPanelView
              listData={values.vehiclesSelected}
              handleChange={handleChange("vehiclesSelected", "list")}
            />
          </Grid>
        </div>
      </form>
    );
  }
}

